import api from '../config/api';

export const verifyToken = async (rawToken) => {
  const res = await api.get(`/token/verify/${rawToken}`);
  return res.data;
};

export const submitManualEntry = async (payload) => {
  const res = await api.post('/guard/manual-entry', payload);
  return res.data;
};

export const getOccupancy = async () => {
  const res = await api.get('/guard/occupancy');
  return res.data;
};

export const listVisitors = async (params) => {
  const res = await api.get('/guard/visitors', { params });
  return res.data;
};
